export const specialPayOverrideCreateConfig = (createSelectOptions) => {
  return [
    {
      step_title: 'Override Info',
      form_title: 'Create Override',
      section: [
        {
          name: 'name',
          input: 'select',
          type: 'single',
          options: createSelectOptions.drivers.map((driver) => driver.name),
          placeholder: 'Select Driver',
          rules: [
            {
              required: true,
              message: 'Driver is required',
            },
          ],
        },
        {
          name: 'rate',
          input: 'inputNumber',
          rules: [
            {
              required: true,
              message: 'Rate is required',
            },
          ],
        },
        {
          name: 'special_pay_item',
          input: 'select',
          type: 'single',
          placeholder: 'Select Pay Item',
          options: createSelectOptions.payItems,
          rules: [
            {
              required: true,
              message: 'Pay Item is required',
            },
          ],
        },
      ],
    },
  ]
}
